import { Suspense, useMemo, useEffect, useState } from 'react'
import { Perf } from 'r3f-perf'
import { Texture } from 'three'
import { SuspenseLoader } from '../../components/suspense'
import { useMeasures } from '../../hooks/state/useMeasures'
import { Layout } from '../../three/layout'
import { TerraceCoverMesh } from '../../three/mesh/terraceCover'
import { Rulers } from '../mesh/terraceCover/ruler/rulers'
import React from 'react'
import { useSetIsSceneLoading } from '@k3/core'

export const EnvironmentMapContext = React.createContext<{
  envMap?: Texture
}>({
  envMap: undefined,
})

export const Background = (): JSX.Element => {
  const { forbiddenTypAmount } = useMeasures()
  return (
    <group>
      <Layout />
      {forbiddenTypAmount && <Suspense fallback={null}>{<Rulers />}</Suspense>}
    </group>
  )
}

export const MontageRoot = (): JSX.Element => {
  const isLocal = useMemo(() => {
    return (
      location.hostname === 'localhost' || location.hostname === '127.0.0.1'
    )
  }, [])

  const { forbiddenTypAmount } = useMeasures()
  const setIsSceneLoading = useSetIsSceneLoading()
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (forbiddenTypAmount) {
      setIsLoaded(true)
    }
  }, [forbiddenTypAmount])

  useEffect(() => {
    setIsSceneLoading(!isLoaded)
  }, [isLoaded, setIsSceneLoading])

  return (
    <Suspense fallback={<SuspenseLoader />}>
      {forbiddenTypAmount && (
        <TerraceCoverMesh onLoad={() => setIsLoaded(true)} />
      )}

      {/* ATTENTION: Perf is getting its font from Google! BUT since it is
              only used locally it shouldnt amount to a DSGVO crime! ;)  */}
      {isLocal && <Perf position="bottom-left" />}
    </Suspense>
  )
}
